import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { browserHistory } from 'react-router';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { PATIENT_HEALTHBOARD } from '../../../constants/routes';
import { isDesktop } from '../../../utils/mobileHelpers';
import { useCareUsers } from '../../Healthboard/useCareUsers';
import NavList from '../../Healthboard/Navigation/NavList';
import ContextBar from '../../ContextBar';
import Loader from '../../common/Loader';
import { PatientPortalCategory } from './PatientPortalCategory';
import { enhance } from './enhance';
import { dependentStatusCheck } from '../../../utils/dependentStatusCheck';

function Navigation({
  intl: { formatMessage },
  isLoggedUser,
  toggleDrawer,
  pending,
  userId,
  loggedUserId,
  setTargetUserId,
  tabs,
  handleSelectTab,
  activeTab,
  showDependentCreatedModal,
  guardianDependentsList,
}) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (activeTab && !expanded) {
      handleSelectTab(activeTab);
      setExpanded(true);
    }
  }, [activeTab]);

  const handleClickOnPerson = id => {
    const isVerified = dependentStatusCheck({
      id,
      guardianDependentsList,
      showDependentCreatedModal,
    });
    if (!isVerified) return;

    browserHistory.push(`${PATIENT_HEALTHBOARD}`);
    setTargetUserId({ id });
    if (!isDesktop()) toggleDrawer();
    setExpanded(true);
  };

  const handleBackButton = () => {
    setExpanded(false);
  };

  const { makeNavList, getTargetUser } = useCareUsers();
  const navigationList = makeNavList(formatMessage);
  const targetUser = getTargetUser(userId);

  const getContextTitle = useCallback(() => {
    if (isLoggedUser) {
      return formatMessage({ id: 'general.labels.me' });
    }
    return get(targetUser, 'displayableName');
  }, [isLoggedUser, targetUser]);

  const dependentList = useMemo(() => {
    const tempList = [];
    navigationList.forEach(({ list }) => {
      list.forEach(item => {
        tempList.push({
          contextUser: {
            avatar: item.avatar,
            id: item.id,
            displayableName: item.displayableName,
            status: item.status,
          },
        });
      });
    });
    return tempList;
  }, [navigationList]);

  if (pending) return <Loader />;

  return (
    <Fragment>
      <ContextBar
        onClick={handleBackButton}
        contextTitle={getContextTitle()}
        contextSubtitle={formatMessage({
          id: 'chat.title.inContextOf',
        })}
        expanded={expanded}
        title={formatMessage({ id: 'general.labels.profiles' })}
        transparent={!expanded}
      />
      <div className="list pl0">
        {!expanded &&
          navigationList.map(item => (
            <NavList
              title={item.title}
              list={item.list}
              key={item.key}
              activeUserId={userId}
              onClick={handleClickOnPerson}
              loggedUserId={loggedUserId}
              subtitleContext={formatMessage({ id: 'general.labels.me' })}
            />
          ))}
        {expanded && (
          <PatientPortalCategory
            formatMessage={formatMessage}
            activeTab={activeTab}
            handleSelectTab={handleSelectTab}
            toggleDrawer={toggleDrawer}
            dependentList={dependentList}
            tabs={tabs}
          />
        )}
      </div>
    </Fragment>
  );
}

Navigation.propTypes = {
  intl: PropTypes.object,
  isLoggedUser: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  pending: PropTypes.bool,
  userId: PropTypes.number,
  setTargetUserId: PropTypes.func,
  tabs: PropTypes.array,
  handleSelectTab: PropTypes.func,
  activeTab: PropTypes.string,
  showDependentCreatedModal: PropTypes.func,
  guardianDependentsList: PropTypes.arrayOf(PropTypes.object),
  loggedUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default enhance(Navigation);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Navigation/index.jsx